interface ProgressBarProps {
  value?: number;
  max?: number;
  label?: React.ReactNode;
}

export default function ProgressBar({ value = 0, max = 100, label }: ProgressBarProps) {
  const ratio = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;

  return (
    <div className="space-y-2">
      {label ? <div className="flex items-center justify-between text-sm text-cocoa/80">{label}</div> : null}
      <div className="h-3 w-full overflow-hidden rounded-full bg-sand/60 shadow-inner">
        <div
          className="h-full rounded-full bg-brick transition-all"
          style={{ width: `${ratio}%` }}
          aria-valuemin={0}
          aria-valuemax={max}
          aria-valuenow={value}
        />
      </div>
      <div className="text-xs text-cocoa/70">{ratio}% funded</div>
    </div>
  );
}
